export default __webpack_public_path__ + "static/media/north-sea.cd45edb7.jpg";